export const getSizeLabel = (min: number): string => {
	if (min === 0) {
		return "";
	}

	//Format the number so it has a comma if over 1000
	const formattedSize = min.toLocaleString("en-US");

	return "From " + formattedSize + " sq. ft.";
};
